import React from 'react';
import { format } from 'react-string-format';
import * as ReactDOM from "react-dom";
import Game from "./Game";
import {NavLink} from "react-router-dom";
import {Card, Col, Container, ListGroup, Row} from "react-bootstrap";
import {TwitterShareButton} from "react-share";

export default class Company extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            currentUserSubscribed: false,
            subscriptionLoaded: false,
            isLoaded: false,
            userId: null,
            loginError: null,
            item: {}
        };
    }

    loadCompany(){
        fetch(process.env.REACT_APP_API_URL + "/customer/publisher/"+this.props.companyId+"/subscribed?user_id="+this.state.userId, {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result);
                    this.setState({
                        currentUserSubscribed: result.subscribed,
                        subscriptionLoaded: true,
                    });
                },

                (error) => {
                    this.setState({
                        subscriptionLoaded: false,
                    });
                }
            )
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        userId: result.id
                    }, this.loadCompany);
                },
                (error) => {
                    this.setState({
                        loginError: "unauthorized",
                    });
                }
            );

        fetch(process.env.REACT_APP_API_URL + "/customer/publisher/"+this.props.companyId+"/stats", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        item: result
                    });
                },

                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    subscribe(e) {
        e.preventDefault();

        const body = {'user_id': this.state.userId};

        fetch(format(process.env.REACT_APP_API_URL + '/customer/publisher/{0}/subscribe-unsubscribe', this.props.companyId), {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(
            (result) => {
                this.componentDidMount();
            },
            (error) => {

            }
        );
    }

    unsubscribe(e) {
        e.preventDefault();

        e.preventDefault();

        const body = {'user_id': this.state.userId};

        fetch(format(process.env.REACT_APP_API_URL + '/customer/publisher/{0}/subscribe-unsubscribe', this.props.companyId), {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(
            (result) => {
                this.componentDidMount();
            },
            (error) => {

            }
        );
    }

    render() {
        const { subscriptionLoaded, currentUserSubscribed, error, isLoaded, item } = this.state;

        const subscriptionForm = currentUserSubscribed ?
                <form onSubmit={this.unsubscribe.bind(this)}>
                    <input class="btn btn-outline-danger" type="submit" value="Unsubscribe"/>
                </form>
                :
                <form onSubmit={this.subscribe.bind(this)}>
                    <input class="btn btn-danger" type="submit" value="Subscribe"/>
                </form>

        let content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if (!isLoaded) {
            content = <div>Loading...</div>;
        } else {
            content = (
                <div id="root" class="alert alert-light">
                    <h1>{item.company.name}</h1>
                    <h3>
                        <a className="link-info" href={item.company.site}>Site</a>
                    </h3>
                    <br/>
                    <div className="row">
                        <div className="col-sm-1">
                            <img width="35" src="https://www.freeiconspng.com/uploads/downloads-icon-15.png"/>
                            <span style={{fontSize: 20}}>{item.downloads}</span>
                        </div>

                        <div className="col-sm-1">
                            <img width="35"
                                 src="https://www.pngall.com/wp-content/uploads/3/Heart-PNG-Photo-Image.png"/>
                            {
                                item.likes_percentage > -1 ?
                                    <span style={{fontSize: 20}}>{item.likes_percentage}%</span>
                                    :<span></span>
                            }
                        </div>

                        <div className="col-sm-1">
                            <img width="35"
                                 src="https://www.pngkey.com/png/full/73-730394_admin-approved-user-registration-user-registration-icon-png.png"/>
                            <span style={{fontSize: 20}}>{item.subscriptions}</span>
                        </div>
                    </div>

                    <br/>
                    <small>On Easy Street from {(new Date(item.company.created_at)).toDateString()}</small>

                    {subscriptionLoaded ? subscriptionForm : <br/>}

                    <br/>
                    <h3>Projects:</h3>
                    {item.company.games.map(game => (
                        <div>
                            <Card style={{ width: '100%' }}>
                                <Card.Img width="100%" height="auto" variant="top" src={game.game_page ? game.game_page.background_image_url : ''} />
                                <Card.ImgOverlay>
                                    <img style={{
                                        borderRadius: 5,
                                        borderWidth: 5,
                                        borderColor: "white",
                                        backgroundColor: "white",
                                        paddingTop: 2,
                                        paddingLeft: 2,
                                        paddingBottom: 2,
                                        paddingRight: 2,
                                        marginTop: "20%"
                                    }} height="20%" src={game.game_page ? game.game_page.icon_url : ''} />
                                </Card.ImgOverlay>
                                <Card.Body>
                                    <Card.Title>{game.name}</Card.Title>
                                    <Card.Text>
                                        <img src="https://cdn-icons-png.flaticon.com/512/2636/2636869.png" width="30px"/>
                                        <span style={{
                                            fontSize: 20
                                        }}>{game.es_index}</span>
                                    </Card.Text>
                                </Card.Body>
                                <ListGroup className="list-group-flush">
                                    <ListGroup.Item>{game.game_category ? "Category: " + game.game_category.name : ""}</ListGroup.Item>

                                    <ListGroup.Item>
                                        <NavLink
                                            to={"/games/" + game.id.toString()}
                                            style={{
                                                marginRight: 10
                                            }}
                                            className={({ isActive }) => (isActive ? 'btn btn-warning' : 'btn btn-warning')}
                                        >
                                            More
                                        </NavLink>
                                        <NavLink
                                            style={{
                                                marginRight: 10
                                            }}
                                            className={({ isActive }) => (isActive ? 'btn btn-primary' : 'btn btn-primary')}
                                        >
                                            <TwitterShareButton
                                                url={"https://easy-street.herokuapp.com/games/" + game.id.toString()}
                                                quote={item.name}
                                                hashtag="#easystreet"
                                            >
                                                Share
                                            </TwitterShareButton>
                                        </NavLink>
                                        <NavLink
                                            to={"/games/" + game.id.toString()}
                                            className={({ isActive }) => (isActive ? 'btn btn-success' : 'btn btn-success')}
                                        >
                                            Download
                                        </NavLink>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card>
                            <br/><br/>
                        </div>
                    ))}
                </div>
            );
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>;
    }
}
